import { Link } from 'react-router';

import { ROUTES } from '@/shared/config';
import { RADIUS, Squircle, StaticSquircle } from '@/shared/ui';

import styles from './SeasonPrizes.module.scss';

/**
 * «Призы за сезон» на главном экране (узел 438:48375).
 *
 * Призы в тексте намеренно не подключены к `/draws/current`: фраза сводит
 * вместе призы РАЗНЫХ месяцев и месячный фонд Фрибетов, а анонс отвечает
 * только про текущий цикл. Половина живых данных вперемешку с копирайтом
 * читалась бы хуже честного плейсхолдера — пункт в `backlog.md`.
 */
export function SeasonPrizes() {
  return (
    <StaticSquircle
      width={390}
      height={696}
      cornerRadius={RADIUS.xl}
      className={styles.root}
    >
      <div className={styles.shapeBox}>
        <img
          className={styles.shapeImage}
          src="/images/season-prizes/shape-bg.svg"
          alt=""
          aria-hidden
        />
      </div>
      <img
        className={styles.prizeImage}
        src="/images/season-prizes/prizes.png"
        alt=""
        aria-hidden
        data-testid="season-prizes-image"
      />

      <h2 className={styles.title}>Призы за сезон!</h2>
      <p className={styles.text}>
        До 8 октября предсказывай исходы матчей Лиги чемпионов, набирай очки и
        получай призы! Nintendo Switch и 100&nbsp;000 Фрибетов ждут тебя
      </p>

      <Squircle asChild cornerRadius={RADIUS.xl}>
        <Link
          className={styles.cta}
          to={ROUTES.draws}
          data-testid="season-prizes-cta"
        >
          Розыгрыши
        </Link>
      </Squircle>
    </StaticSquircle>
  );
}
